export function generateLightColor() {
  const r = Math.floor(Math.random() * (255 - 192)) + 192;
  const g = Math.floor(Math.random() * (255 - 192)) + 192;
  const b = Math.floor(Math.random() * (255 - 192)) + 192;

  return `rgb(${r},${g},${b})`;
}



// WEBPACK FOOTER //
// ./src/helpers/colors.js